import React from 'react';
import TextField from '@material-ui/core/TextField';
import {makeStyles} from '@material-ui/core/styles';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
const filter = createFilterOptions();

const useStyles = makeStyles({
    root: {
      '& .MuiInputLabel-formControl': {
        transform: 'none !important',
      },
    },
});


const renderOptionLabel = (category) => {
    if (!category) return
    let icon
    switch(category){
        case "Cautions":
            icon = <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM10 17H8V15H10V17ZM10 13H8V7H10V13ZM9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4Z" fill="#E28F2C" />
            </svg>
            break;
        case 'Warnings':
            icon = <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 17H20L10 0L0 17ZM10.9091 14.3158H9.09091V12.5263H10.9091V14.3158ZM10.9091 10.7368H9.09091V7.15789H10.9091V10.7368Z" fill="#D7493F" />
            </svg>
            break;
        case 'Notes':
            icon = <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.9592 4.95917L11.5317 0.531667C11.1925 0.1925 10.725 0 10.2392 0H1.83333C0.825 0 0 0.825 0 1.83333V14.6667C0 15.675 0.825 16.5 1.83333 16.5H14.6667C15.675 16.5 16.5 15.675 16.5 14.6667V6.26083C16.5 5.775 16.3075 5.3075 15.9592 4.95917ZM3.66667 3.66667H10.0833V5.5H3.66667V3.66667ZM12.8333 12.8333H3.66667V11H12.8333V12.8333ZM12.8333 9.16667H3.66667V7.33333H12.8333V9.16667Z" fill="#216B94" />
            </svg>
            break;
        default:
            icon = <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5536 10.1514L11.7679 8.05072C11.8408 7.91714 11.8165 7.75929 11.695 7.66214L10.4079 6.65429C10.4443 6.47214 10.4565 6.26572 10.4565 6.07143C10.4565 5.87714 10.4443 5.67072 10.4079 5.47643L11.695 4.46857C11.8043 4.37143 11.8408 4.21357 11.7679 4.08L10.5536 1.97929C10.4808 1.84571 10.3229 1.79714 10.1772 1.84571L8.67148 2.45286C8.35576 2.21 8.01576 2.01571 7.65148 1.85786L7.42076 0.255C7.39648 0.109286 7.2629 0 7.11719 0H4.68862C4.5429 0 4.40933 0.109286 4.38505 0.255L4.15433 1.87C3.79005 2.02786 3.4379 2.22214 3.13433 2.465L1.62862 1.85786C1.49505 1.80929 1.33719 1.85786 1.25219 1.99143L0.0379046 4.09214C-0.0349525 4.21357 0.00147598 4.38357 0.110762 4.48071L1.3979 5.48857C1.36148 5.67071 1.34933 5.87714 1.34933 6.07143C1.34933 6.26572 1.36148 6.47214 1.3979 6.66643L0.110762 7.67429C0.00147598 7.77143 -0.0349525 7.94143 0.0379046 8.06286L1.25219 10.1636C1.32505 10.2971 1.4829 10.3457 1.62862 10.2971L3.13433 9.69C3.45005 9.93286 3.79005 10.1271 4.15433 10.285L4.38505 11.8879C4.40933 12.0336 4.5429 12.1429 4.68862 12.1429H7.11719C7.2629 12.1429 7.39648 12.0336 7.42076 11.8879L7.65148 10.285C8.01576 10.1271 8.3679 9.93286 8.67148 9.69L10.1772 10.2971C10.3229 10.3336 10.4686 10.285 10.5536 10.1514ZM5.9029 7.89286C4.89505 7.89286 4.08148 7.06714 4.08148 6.07143C4.08148 5.06357 4.89505 4.25 5.9029 4.25C6.89862 4.25 7.72433 5.06357 7.72433 6.07143C7.72433 7.06714 6.89862 7.89286 5.9029 7.89286Z" fill="#248D35" />
                <path d="M16.7719 14.317L15.9948 13.7098C16.0069 13.5884 16.0191 13.4791 16.0191 13.3577C16.0191 13.2363 16.0069 13.1148 15.9948 13.0056L16.7719 12.3984C16.8326 12.3377 16.8569 12.2406 16.8205 12.1677L16.0919 10.9048C16.0434 10.8198 15.9584 10.7956 15.8612 10.8198L14.9626 11.1841C14.7684 11.0384 14.5741 10.917 14.3434 10.832L14.2098 9.8727C14.1855 9.77556 14.1005 9.71484 14.0155 9.71484H12.5584C12.4734 9.71484 12.3884 9.77556 12.3762 9.8727L12.2426 10.832C12.0241 10.9291 11.8176 11.0384 11.6234 11.1841L10.7248 10.8198C10.6398 10.7956 10.5548 10.8198 10.4941 10.9048L9.7655 12.1677C9.71693 12.2527 9.74122 12.3377 9.81408 12.3984L10.5912 13.0056C10.5791 13.127 10.5669 13.2363 10.5669 13.3577C10.5669 13.4791 10.5791 13.6006 10.5912 13.7098L9.81408 14.317C9.75336 14.3777 9.72908 14.4748 9.7655 14.5477L10.4941 15.8106C10.5426 15.8956 10.6276 15.9198 10.7248 15.8956L11.6234 15.5313C11.8176 15.677 12.0119 15.7984 12.2426 15.8834L12.3762 16.8427C12.3884 16.9398 12.4612 17.0006 12.5584 17.0006H14.0155C14.1005 17.0006 14.1855 16.9398 14.1976 16.8427L14.3312 15.8834C14.5498 15.7863 14.7562 15.677 14.9384 15.5313L15.8491 15.8956C15.9341 15.9198 16.0191 15.8956 16.0798 15.8106L16.8084 14.5477C16.8569 14.4748 16.8326 14.3777 16.7719 14.317ZM13.3598 14.572C12.6919 14.572 12.1455 14.0256 12.1455 13.3577C12.1455 12.6898 12.6919 12.1434 13.3598 12.1434C14.0276 12.1434 14.5741 12.6898 14.5741 13.3577C14.5741 14.0256 14.0276 14.572 13.3598 14.572Z" fill="#248D35" />
            </svg>
        }
    return <div className="flex-apart max-width">
        <p>{category}</p>
        {icon}
    </div>
}
export default function CategorySelection(props) {
    const classes = useStyles();
    return (
        <Autocomplete
            // value={props.category}
            // defaultValue={props.category}
            onChange={(event, newValue) => {
                if (typeof newValue === 'string') {
                    //when a user submits a new category (by hitting enter)
                    props.addCategoryToInfoItem(newValue, props.infoItem)
                } else if (newValue && newValue.inputValue) {
                    // Create a user clicks "add..." button
                    props.addCategoryToInfoItem(newValue.inputValue, props.infoItem)
                } else {
                    // when a previously existing selection is made/cancelled
                    if (newValue && newValue.title) {
                        props.addCategoryToInfoItem(newValue.title, props.infoItem)
                    }
                }
            }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);

                // Suggest the creation of a new value
                if (params.inputValue !== '') {
                    filtered.push({
                        inputValue: params.inputValue,
                        title: `Add "${params.inputValue}"`,
                    });
                }

                return filtered;
            }}
            // autoSelect
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id="free-solo-with-text-demo"
            options={props.categories}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                    return option.inputValue;
                }
                // Regular option
                return option.title;
            }}
            renderOption={(option) => renderOptionLabel(option.title)}
            className={classes.root}

            // The height and marginTop are extremely important here. Do not change unless you want to put column out of wack
            
            style={{ width: "100%", height: '32px', marginTop: '10px'}}
            freeSolo
            renderInput={(params) => (
                <TextField 
                    {...params} 
                    placeholder="Pick a Category" 
                    label={renderOptionLabel(props.category)}
                    InputProps={{ ...params.InputProps }} 
                />
            )}
        />
    );
}